import * as React from 'react'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'

const DeleteUserContactDialogContent: React.FC<{ contactEmail: string }> = ({ contactEmail }) => {
  const { t } = useTranslation()

  return (
    <>
      <DialogTitle id="alert-dialog-title">{`${t('delete-contact')} ${contactEmail}`}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{t('delete-contact-text')}</DialogContentText>
      </DialogContent>
    </>
  )
}

export default DeleteUserContactDialogContent
